import React from "react"

import { PreferenceCenter } from "@ua/web-sdk/lib/remote-data/preference-center"
import { SubscriptionOperatorProps } from "./types"
import Section from "./Section"
import Header from "./Header"

export type Operation = "subscribe" | "unsubscribe"

export interface Props extends SubscriptionOperatorProps {
  definition: PreferenceCenter
}

const PreferenceCenter: React.FC<Props> = ({ definition, ...props }) => {
  const sections = definition.sections.map((section) => (
    <Section key={section.id} section={section} {...props} />
  ))
  return (
    <>
      {definition.display && <Header type="heading" {...definition.display} />}
      {sections}
    </>
  )
}

export default PreferenceCenter
